import { render, staticRenderFns } from "./ViewAdvertisement.vue?vue&type=template&id=68ad39d2&scoped=true&"
import script from "./ViewAdvertisement.vue?vue&type=script&lang=js&"
export * from "./ViewAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./ViewAdvertisement.vue?vue&type=style&index=0&id=68ad39d2&prod&scoped=true&lang=css&"
import style1 from "./ViewAdvertisement.vue?vue&type=style&index=1&id=68ad39d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad39d2",
  null
  
)

export default component.exports